import React from 'react'
import {useRouteLoaderData} from '@remix-run/react'
import {useReportWidgetSeen} from '~/hooks/analytic-hooks'

import type {RootLoaderResponse} from '~/types'
import {getTranslation} from '~/localization/translation'

const TrustUsBrandsSection = () => {
  const {language} = useRouteLoaderData('root') as RootLoaderResponse
  const translations = getTranslation(language)

  const [widgetRef] = useReportWidgetSeen({
    widget_name: 'trust-us-brands-section',
    widget_place: 'middle',
  })

  return (
    <div className="flex flex-col gap-3" ref={widgetRef}>
      <div className="flex flex-row justify-between rounded-xl bg-blue-100 p-6 tablet:flex-col tablet:gap-10">
        <span className="text-xl font-medium text-gray-900">{translations.Badge.trustUsBrands}</span>
        <img
          alt="trust us brands"
          src="https://d3agh3dpu1smgs.cloudfront.net/maga/static/brands_trust_us.webp"
          loading="lazy"
          className="h-[69px] w-[311px] object-scale-down mix-blend-multiply"
        />
      </div>
    </div>
  )
}

export default TrustUsBrandsSection
